import './SliderElement.css';

export default function SliderElement({element,style}) {
    const redirect = (item)=>{
        const base = `https://${import.meta.env.VITE_SITE_DOMAIN}`;
        const target = item?.handle
            ? `${base}/produkt/${item.handle}`
            : `${base}/produkt?id=${encodeURIComponent(item?.id ?? "")}`;
        window.location.href = target;
    }

    return <div className="slider-element" style={style} onClick={()=>redirect(element)}>
        <div className="slider-element-image">
            <img loading="lazy" src={element.image} alt={element.alt || element.name || 'Produkt'} />

        </div>
        <div className="slider-element-category">{element.category || "Produkt"}</div>
        <div className="slider-element-details-container">
            <div className="slider-element-name">{element.name}</div>
            <div className="slider-element-price">{(element.price).toFixed(2)} zł</div>
        </div>
    </div>;
}
